// extracted by mini-css-extract-plugin
export default {"container":"performance-indicators_container__n5sUW"};